import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './buynow.css';
import SearchIcon from '@mui/icons-material/Search';
import { Divider } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { BASE_URL } from '../helper';

export default function Order() {
  const [isLoading, setIsLoading] = useState(true);
  const [orderData, setOrderData] = useState({});
  const [addressIds, setAddressIds] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const [searchInput, setSearchInput] = useState('');

  const fetchMyOrder = async () => {
    const userEmail = localStorage.getItem('userEmail');
    const response = await fetch(`${BASE_URL}/api/myOrderData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: userEmail,
      }),
    });
    const data = await response.json();
    setOrderData(data);
  };

  const getAddressData = async () => {
    try {
      const addressDataArray = [];

      for (const id of addressIds) {
        const response = await fetch(`${BASE_URL}/api/getaddressId`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ addressId: id }),
        });

        if (!response.ok) {
          throw new Error(response.statusText);
        }

        const data = await response.json();
        addressDataArray.push(data);
      }

      setAddressData(addressDataArray);
    } catch (error) {
      console.error('Error fetching address data:', error);
    }
  };


  const onClickDelete = async (addressId) => {
    try {
      const response = await fetch(`${BASE_URL}/api/deleteOrder`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: localStorage.getItem('userEmail'),
          addressId: addressId,
        }),
      });
  
      if (response.ok) {
        fetchMyOrder();
      } else {
        // Handle error if the order deletion was unsuccessful
        console.error('Failed to delete order');
      }
    } catch (error) {
      console.error('Error deleting order:', error);
    }
  };
  
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchMyOrder();
        setTimeout(() => {
          setIsLoading(false);
        }, 3000); // seconds delay
      } catch (error) {
        console.error('Error fetching order data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (
      orderData &&
      orderData.orderData &&
      orderData.orderData.order_data &&
      orderData.orderData.order_data.length > 0
    ) {
      const orderDataArray = orderData.orderData.order_data;
      const addressIdsArray = orderDataArray.flatMap((item) =>
        item.map((arrayData) => arrayData.addressId)
      );
      setAddressIds(addressIdsArray);
    }
  }, [orderData]);

  useEffect(() => {
    if (addressIds.length > 0) {
      getAddressData();
    }
  }, [addressIds]);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(-1);
  };

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const filteredOrderData = orderData.orderData?.order_data?.filter((item) => {
    const matchingItems = item.filter((arrayData) => {
      const title = arrayData.shortTitle.toLowerCase();
      const search = searchInput.toLowerCase();
      return title.includes(search);
    });
    return matchingItems.length > 0;
  });

  if (isLoading) {
    return (
      <div className="cart_section">
        <div className="circle">
          <CircularProgress />
          <h2>Loading....</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="buynow_section">
      <div className="buynow_container">
        <div className="order_heading">
          <h3>Your order</h3>
          <div className="nav_searchbaar d-flex">
            <input
              type="text"
              name=""
              id=""
              placeholder="Search"
              value={searchInput}
              onChange={handleSearchInputChange}
            />
            <div className="search_icon">
              <SearchIcon id="search" />
            </div>
          </div>
        </div>
      </div>
      {filteredOrderData && filteredOrderData.length > 0 ? (
        filteredOrderData.slice(0).reverse().map((item, index) =>
          item.map((arrayData, subIndex) => {
            const deliveryDate = new Date(arrayData.date);
            deliveryDate.setDate(deliveryDate.getDate() + 6);
            const formattedDeliveryDate = deliveryDate.toLocaleDateString('en-US', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
            });

            const matchingAddressData = addressData.find(
              (address) => address && address._id === arrayData.addressId
            );

            const isHovered = hoveredIndex === index;

            return (
              <div className="buynow_container order_container" key={index}>
                <div className="left_buy order-part">
                  <div className="order_header">
                    <span className="order_lable">Order placed</span>
                    <span className="order_lable">total</span>
                    <span className="order_lable">ship to</span>
                    <span className="order_lable">Order #</span>
                  </div>
                  <div className="order_header">
                    <span className="order_lable_2">{arrayData.date}</span>
                    <span className="order_lable_2">₹{arrayData.price + 50}.00</span>
                    <span
                      className={`order_lable_2 ${isHovered ? 'dropdown-open' : ''}`}
                      onMouseEnter={() => handleMouseEnter(index)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <NavLink to="#" className="dropdown-link">
                        {matchingAddressData && matchingAddressData.fname}
                      </NavLink>
                      {isHovered && (
                        <div className="dropdown-menu">
                          {matchingAddressData ? (
                            <p className="dropdown-item">
                              <strong>{matchingAddressData.fname},</strong>
                              <br />
                              {matchingAddressData.address} {matchingAddressData.area},
                              <br />
                              {matchingAddressData.city}, {matchingAddressData.state}, {matchingAddressData.pincode},
                              <br />
                              phone number: {matchingAddressData.mobile}
                            </p>
                          ) : (
                            <p className="dropdown-item">No address found.</p>
                          )}
                        </div>
                      )}
                    </span>
                    <span className="order_lable_2">4565447986</span>
                  </div>
                  <Divider />
                  <h5 className="mt-2">Delivered {formattedDeliveryDate}</h5>
                  <div className="item_containert">
                    <img src={arrayData.img} alt="imgitem" />
                    <div className="item_details">
                      <h5>{arrayData.shortTitle}</h5>
                      <h5>{arrayData.longTitle}</h5>
                      <p className="unusuall">Usually dispatched in 8 days.</p>
                      <div className="add_remove_select">
                        <span className="bg-gray">QTY: {arrayData.quantity}</span>
                      </div>
                      <button className="place_oder_btn" onClick={() => onClickDelete(arrayData.addressId)} style={{ marginLeft: '0px' }}>
                        Order cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )
      ) : (
        <h3 style={{ textAlign: 'center' }}>No Order</h3>
      )}
    </div>
  );
}